import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Trip.css";
import { Breadcrumb, PageHeader, Glyphicon } from "react-bootstrap";
import ListTrip from "./ListTrip";
import Joyride from 'react-joyride';

export default class Trip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      runJoy: false,
      steps: [
    	{
    	  target: '.datePicker ',
    	  content: 'Puedes cambiar el rango de consulta. Tienes una fecha absoluta y una relativa para elegir',
    	  placement: 'top'
    	},
        {
          target: '.react-bs-table-container',
          content: 'Puedes filtrar los vehículos.',
          placement: 'top'
        },
        {
          target: '.tripLink',
          content: 'Para ver el detalle del vehículo puedes seleccionar este enlace',
          placement: 'top'
        },
        {
          target: '.progress-bar',
          content: 'Por cada vehículo se muestra un puntaje de seguridad y ecología.',
          placement: 'bottom'
        },
        {
          target: '.btnCompare',
          content: 'Si seleccionas más de 1 fila puedes compararlos con este botón',
          placement: 'top'
        }
      ]
    };
  }

  handleHelp = () => {
	this.setState({ runJoy: true});
  }

  render() {
	const { steps, runJoy } = this.state;
	return (
      <div className="Trip">
        <Joyride
		    steps={steps}
		    run={runJoy}
			continuous={true}
			scrollToFirstStep={true}
			callback={this.callback}
			locale={{ back: 'Atrás', close: 'Cerrar', last: 'Finalizar', next: 'Siguiente', skip: 'Saltar' }}
		/>
	    <Breadcrumb>
		  <Breadcrumb.Item componentClass={Link} href="/" to="/">Home</Breadcrumb.Item>
	      <Breadcrumb.Item active>Viajes</Breadcrumb.Item>
	      <Glyphicon className="help" glyph="info-sign" onClick={this.handleHelp} />
		</Breadcrumb>
	  	<PageHeader>
	      Resumen de flota
	    </PageHeader>
	    <ListTrip {...this.props} />
	  </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/trip/Trip.js